/* Salt & Creek — Collection carousel: prev/next controls for every instance on the page.
   Re-initialises when the theme editor loads or re-renders a section. */
(function () {
  function init(root) {
    if (!root || root.dataset.sccInit === '1') return;
    var track = root.querySelector('.sc-cc__track');
    var prev = root.querySelector('.sc-cc__prev');
    var next = root.querySelector('.sc-cc__next');
    if (!track) return;
    root.dataset.sccInit = '1';

    function step() {
      var card = track.querySelector('.sc-cc__slide');
      if (!card) return track.clientWidth * 0.8;
      var cs = getComputedStyle(track);
      var gap = parseInt(cs.columnGap || cs.gap || '16', 10) || 16;
      var multiplier = window.matchMedia('(min-width: 1000px)').matches ? 2 : 1;
      return (card.getBoundingClientRect().width + gap) * multiplier;
    }
    function update() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.disabled = track.scrollLeft <= 0;
      next.disabled = track.scrollLeft >= maxScroll;
    }
    function go(dir) {
      track.scrollBy({ left: step() * dir, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.sc-cc').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
})();
